import React, { Component } from 'react';
import MultiCard from './../../pages/accountLinking/MultiCard';
import './MultiCard.css';

import Config from './../../constants/config';
import AxiosDataService from '../../services/AxiosDataService';
import { connect } from 'react-redux';

class MultiCardPage extends Component {
  constructor(props, context) {
    super(props, context);
  };

  componentWillMount() {
    const getSessionInput = {
      url: window.location.origin + '/web/cardissuer/accntlinking/getSession/' + Config.merchantName,
      method: 'get',
      flag: 'app'
    }

    AxiosDataService.fetch(getSessionInput).then(Sessionresponse => {
      const orgID = Sessionresponse.data.orgID
      const SessionID = Sessionresponse.data.sessionID
      this.props.dispatch({
        type: 'SESSIONID_RESPONSE',
        sessionID: SessionID,
      });
      if (SessionID) {
        var tagJS = document.createElement('script');
        tagJS.id = "tagsJS"
        tagJS.type = "text/javascript";
        tagJS.src = "https://content.discover.com/fp/tags.js?org_id=" + orgID + "&session_id=" + SessionID;
        document.body.appendChild(tagJS);
      }
    });
  }

  render() {
    return (

      <div className="multicard-block">
        <MultiCard />
      </div>
    );
  }
}
export default connect()(MultiCardPage)
